export const education = [
  {
    degree: "B.Tech - Computer Science & Engineering",
    institution: "Parul University",
    location: "Vadodara, India",
    period: "2022 – 2026",
    gpa: "CGPA: 7.76",
    coursework: ["Data Structures & Algorithms", "Database Management Systems", "Software Engineering", "Web Development", "Machine Learning", "Computer Networks"],
    achievements: ["Academic Excellence", "Technical Projects Portfolio"]
  },
  {
    degree: "12th Standard",
    institution: "Kendriya Vidyalaya",
    location: "Muzaffarpur, India",
    period: "2022",
    gpa: "Percentage: 66.60%",
    coursework: ["Physics", "Chemistry", "Mathematics", "Computer Science"],
    achievements: ["CBSE Board Certification", "Science Stream Completion"]
  },
  {
    degree: "10th Standard",
    institution: "CBSE",
    location: "India",
    period: "2020",
    gpa: "Percentage: 74.80%",
    coursework: ["Mathematics", "Science", "Social Science", "English", "Hindi"],
    achievements: ["CBSE Board Certification", "All India Secondary School Examination"]
  }
];
